import type { SVGProps } from 'react';

const Svg2022UadCommentReply = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20 10.002c-.55 0-1 .45-1 1v3c0 .55-.45 1-1 1s-1 .45-1 1v2.87l-4.08-3.4c-.36-.3-.81-.46-1.28-.46H6c-.55 0-1-.45-1-1v-8.01c0-.55.45-1 1-1h5c.55 0 1-.45 1-1s-.45-1-1-1H6c-1.65 0-3 1.35-3 3v8c0 1.65 1.35 3 3 3h5.64l4.08 3.4a1.99 1.99 0 0 0 2.13.28c.71-.33 1.15-1.03 1.15-1.81v-2.04c1.16-.41 2-1.52 2-2.83v-3c0-.55-.45-1-1-1"
    />
    <path
      fill="currentcolor"
      d="M7 8.002c0 .55.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1m0 4c0 .55.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1m11.963-9.009h-1.59l1.29-1.29a.996.996 0 1 0-1.41-1.41l-3 3a.996.996 0 0 0 0 1.41l3 3c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-1.29-1.29h1.59c1.65 0 3 1.35 3 3 0 .55.45 1 1 1s1-.45 1-1c0-2.76-2.24-5-5-5z"
    />
  </svg>
);
export default Svg2022UadCommentReply;
